import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
// import store from '@/store'
// import { getToken } from '@/util/auth'
import errorCode from '@/util/errorCode'
import {
  messages
} from '@/util/resetMessage';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

// axios.defaults.headers['Content-Type'] = "application/x-www-form-urlencoded"
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://121.41.8.207:8099',
  baseURL: 'https://videoapi.terabits.cn',
  // baseURL: 'https://testrecord.terabits.cn/backstage-api',

  // baseURL: "http://192.168.1.243:8099",
  // baseURL:'http://192.168.1.61:9003',
  // 超时
  // timeout: 30000
})
// request拦截器
service.interceptors.request.use(config => {
  config.headers.authorization = `Bearer ${localStorage.getItem(
    "token"
  )}`;
  // 是否需要设置 token
  // const isToken = (config.headers || {}).isToken === false
  // if (getToken() && !isToken) {
  //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  // }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            if (value[key] !== null && typeof (value[key]) !== 'undefined') {
              let params = propName + '[' + key + ']';
              let subPart = encodeURIComponent(params) + '=';
              url += subPart + encodeURIComponent(value[key]) + '&';
            }
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || res.data.status || 200;
  // 获取错误信息
  const msg = errorCode[code] || res.data.data || res.data.msg || res.data.message || errorCode['default']
  if (code === 401) {
    if (res.data.message.includes( "登录失败")) {
      console.log(res.data.message);
      messages.error({ message: "登录失败：账号或密码错误" })
    } else {
      console.log(res);
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).then(() => {
        localStorage.clear()
        location.href = '/login';
      }).catch(() => { });
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    }

  } else
    if (code === 500) {
      if (res.data.status === 500) {
        Message({
          message: res.data.message,
          type: 'error'
        })
      } else {
        Message({
          message: msg,
          type: 'error'
        })
      }

      return Promise.reject(new Error(msg))
    } else if (code === 50 || code === 51 || code === 13 || code === 1002 || code === 1008 || code === 5 || code === 39 || code === 36) {
      Message({
        message: res.data.message,
        type: 'error'
      })
      return Promise.reject(new Error(msg))
    }
    else if (code === 1000) {
      Message({
        message: res.data.message,
        type: 'error'
      })
      location.href = '/';
      return Promise.reject(new Error(msg))
    } else if (code !== 200 && code !== 1) {
      // Notification.error({
      //   title: msg
      // })
      Message({
        message: msg,
        type: 'error'
      })
      return Promise.reject('error')
    } else {
      return res.data
    }
},
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      messages.error({ message: "后端接口连接异常" })
    }
    else if (message.includes("timeout")) {
      messages.error({ message: "系统接口请求超时" })
    }
    else if (message.includes("Request failed with status code")) {
      // message = "系统接口" + message.substr(message.length - 3) + "异常";
      messages.error({ message: "系统接口" + message.substr(message.length - 3) + "异常" })
      MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }
      ).then(() => {
        // store.dispatch('FedLogOut').then(() => {
        //   location.href = '/login';
        // })
      }).catch(() => { });
    }
    // Message({
    //   message: message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
